export default __webpack_public_path__ + "static/media/MATHEMATICS_EXPRESSIONS_AND_EQUATIONS.b00a5165.svg";